import { MeetingStatus } from '@govinity/validation';
/**
 * Raw orange because no semantic Badge variant is orange (`variant="warning"` is yellow); matches the
 * shared off-air pill in `stream-status-badge.tsx` (no border). State is always carried in text (WCAG).
 */
export var RECESS_BADGE_CLASS = 'bg-orange-500/15 text-orange-700 dark:text-orange-300';
/**
 * A recessed meeting is still `status = Live`, so recess can't ride the `STATUS_VARIANT` map — it only
 * applies to a live meeting, never a stale flag on a completed/cancelled one.
 */
export function isRecessStatusDisplay(displayStatus, isRecessed) {
    return displayStatus === MeetingStatus.Live && isRecessed;
}
